import React from "react";
import { useEffect, useState } from "react";
import StoreActions from "store/actions/system";
import { useDispatch, useSelector } from "react-redux";
import Actions from "modules/entity/actions";
import EntityForm from "modules/entity/forms";
import SalesByDay from "pages/Main/Dashboard/components/SalesByDay";
import SalesByCategory from "pages/Main/Dashboard/components/SalesByCategory";
import dayjs from "dayjs";
import DateFilterWrap from "components/DateFilter/wrap";
import qs from "qs";
import TopDishes from "pages/Main/Dashboard/components/TopDishes";
import TopWaiters from "pages/Main/Dashboard/components/TopWaiters";
import get from "lodash/get";
import MainOrganizationStorageLeftovers from "pages/Main/Storage/storages";
import CashRegister from "pages/Main/Dashboard/components/CashRegister";
import { Spinner } from "components";
import useTranslation from "hooks/useTranslation";
import { Field } from "formik";
import { Fields } from "uicomponents";
import auth from "store/actions/auth";
import { helpers } from "services";
import { Table } from "antd";
import { rowClassName } from "utils";
import { isEmpty } from "lodash";
import { useLocation, useNavigate } from "react-router-dom";
import InputTransactions from "pages/Main/Dashboard/components/input-transactions";
import OutputTransactions from "pages/Main/Dashboard/components/output-transactions";
import CommonTransactions from "pages/Main/Dashboard/components/common-transactions";
import MainOrganizationStorageIncomes from "pages/Main/Storage/incomes";
import MainOrganizationStorageConsumption from "pages/Main/Storage/consumption";
import { BanknoteArrowDown } from "lucide-react";
import useStartHoursOfCompanyInSeconds from "hooks/useStartHoursOfCompanyInSeconds";
import statusUpIcon from "pages/Dashboard/icons/status-up.svg";
import shoppingCartIcon from "pages/Dashboard/icons/shopping-cart.svg";
import emptyWalletIcon from "pages/Dashboard/icons/empty-wallet.svg";
import moneyReciveIcon from "pages/Dashboard/icons/money-recive.svg";
import moneySendIcon from "pages/Dashboard/icons/money-send.svg";
import dollarCircleRedIcon from "pages/Dashboard/icons/dollar-circle-red.svg";
import dollarCircleIcon from "pages/Dashboard/icons/dollar-circle.svg";
import importIcon from "pages/Dashboard/icons/import.svg";
import exportIcon from "pages/Dashboard/icons/export.svg";
import boxIcon from "pages/Dashboard/icons/box.svg";
import convertRedIcon from "pages/Dashboard/icons/convert-red.svg";
import convertIcon from "pages/Dashboard/icons/convert.svg";

function MainOrganizationDashboard() {
	const location = useLocation();
	const navigate = useNavigate();
	const { tr } = useTranslation();
	const [isLoading, setLoading] = useState(true);
	const dispatch = useDispatch();
	const authStore = useSelector(state => state.auth);
	const isMainOrganization = get(authStore, "is_main_organization", false);
	const defaultCurrency = get(authStore, "default_currency_code");
	const activeOrganization = get(authStore, "activeOrganization");
	const organizations = get(authStore, "organizations", []).filter(
		organization => organization.is_main !== 0
	);

	const defaultCurrencyLabel = helpers.getCurrencyLabel(defaultCurrency, tr);

	const startHoursInSeconds = useStartHoursOfCompanyInSeconds();

	const { start, end } = (() => {
		const query = qs.parse(location.search, { ignoreQueryPrefix: true });

		if (query.start_at && query.end_at)
			return { start: query.start_at, end: query.end_at };

		return {
			start:
				dayjs()
					.startOf("day")
					.unix() + startHoursInSeconds,
			end:
				dayjs()
					.endOf("day")
					.unix() + startHoursInSeconds
		};
	})();

	const [categoriesByPrice, setCategoriesByPrice] = useState([]);
	const [topDishes, setTopDishes] = useState([]);
	const [waiters, setWaiters] = useState([]);
	const [selectedKey, setSelectedKey] = useState("sales");
	const [dashboardData, setDashboardData] = useState(null);

	const [totals, setTotals] = useState({
		sales: 0,
		orders: 0,
		cashboxes: 0,
		inputTransactions: 0,
		outputTransactions: 0,
		inputProducts: 0,
		outputProducts: 0,
		commonTransactions: 0
	});

	const loadCategoriesSalePrice = (orgId = null) => {
		dispatch(
			Actions.LoadDefault.request({
				url: isMainOrganization
					? `/main/dashboard/sales-by-product-category`
					: "/dashboard/sales-by-product-category",
				params: {
					extra: {
						start_at: start,
						end_at: end,
						...(orgId ? { organization_id: orgId } : {})
					}
				},
				cb: {
					success: data => {
						if (Array.isArray(data)) {
							setCategoriesByPrice(
								data.reduce(
									(prev, curr) => [
										...prev,
										curr.name === null
											? {
												...curr,
												name: "Без категории"
											}
											: curr
									],
									[]
								)
							);
						}
					},
					error: () => { }
				}
			})
		);
	};

	const loadTopDishes = (orgId = null) => {
		dispatch(
			Actions.LoadDefault.request({
				url: isMainOrganization
					? `/main/dashboard/top-dishes`
					: `/dashboard/top-dishes`,
				params: {
					extra: {
						start_at: start,
						end_at: end,
						...(orgId ? { organization_id: orgId } : {})
					}
				},
				cb: {
					success: data => {
						setTopDishes(data);
					},
					error: () => { }
				}
			})
		);
	};

	const loadWaiters = (orgId = null) => {
		dispatch(
			Actions.LoadDefault.request({
				url: isMainOrganization ? `/main/reports/waiter` : `/reports/waiter`,
				params: {
					extra: {
						start_at: start,
						end_at: end,
						...(orgId ? { organization_id: orgId } : {})
					}
				},
				cb: {
					success: data => {
						const sortedArr = data.sort(
							(a, b) => Number(b.goods_price) - Number(a.goods_price)
						);
						setWaiters(sortedArr);
					},
					error: () => { }
				}
			})
		);
	};

	const loadDashboardData = (orgId = null) => {
		setLoading(true);
		dispatch(
			Actions.LoadDefault.request({
				url: isMainOrganization ? `/main/dashboard/get` : `/dashboard/main`,
				params: {
					extra: {
						keys:
							"commonTransactions,allExpence,orders,sales,inputTransactions,outputTransactions,cashboxes,storage,outputProductsTotal,inputProductsTotal,debtorCreditor,cashbox",
						start_at: start,
						end_at: end,
						...(orgId ? { organization_id: orgId } : {})
					}
				},
				cb: {
					success: data => {
						setLoading(false);
						setDashboardData(data);

						const sales = get(data, "sales.total", {});
						const orders = get(data, "orders.total", {});
						const cashboxes = get(data, "cashboxes.total.balance", {});
						const inputTransactions = get(data, "inputTransactions.total", {});
						const outputTransactions = get(
							data,
							"outputTransactions.total",
							{}
						);

						const inputProducts = get(data, "inputProductsTotal");
						const outputProducts = get(data, "outputProductsTotal");
						const commonTransactions = get(
							data,
							"commonTransactions.total",
							{}
						);

						setTotals({
							sales,
							orders,
							inputTransactions,
							outputTransactions,
							inputProducts,
							outputProducts,
							commonTransactions,
							cashboxes
						});
					},
					error: () => {
						setLoading(false);
					}
				}
			})
		);
	};

	useEffect(() => {
		dispatch(StoreActions.SetToolbarTitle(`Dashboard`));
	}, []);

	useEffect(() => {
		loadTopDishes(activeOrganization);
		loadWaiters(activeOrganization);
		loadDashboardData(activeOrganization);
		loadCategoriesSalePrice(activeOrganization);
	}, [start, end, activeOrganization]);

	const {
		sales,
		orders,
		cashboxes,
		inputTransactions,
		outputTransactions,
		inputProducts,
		outputProducts,
		commonTransactions
	} = totals;

	const debtor = get(
		dashboardData,
		`debtorCreditor.${defaultCurrency}.debtor`,
		0
	);
	const creditor = get(
		dashboardData,
		`debtorCreditor.${defaultCurrency}.creditor`,
		0
	);

	const salesByFilialTableData = (() => {
		try {
			const dashboardDataSales = get(dashboardData, "sales", {});

			// Hash{} to List[]
			const data = Object.values(
				get(dashboardDataSales, "organizations", {})
			).map((saleByFilial, idx) => {
				const data = {
					id: saleByFilial.id,
					name: saleByFilial.name,
					count: saleByFilial.total
				};

				if (!isEmpty(saleByFilial.payments)) {
					data["children"] = Object.entries(saleByFilial.payments).map(
						([name, count]) => {
							return {
								name,
								count
							};
						}
					);
				}

				return data;
			});

			return [
				{ name: tr("Итого"), count: get(dashboardDataSales, "total", []) },
				...data
				//
			];
		} catch (error) {
			return [];
		}
	})();

	const ordersByFilialTableData = (() => {
		try {
			const dashboardDataOrders = get(dashboardData, "orders", {});

			// Hash{} to List[]
			const data = get(dashboardDataOrders, "organizations", []).map(
				(orderByFilial, idx) => {
					const data = {
						id: orderByFilial.id,
						name: orderByFilial.name,
						count: orderByFilial.total
					};

					if (!isEmpty(orderByFilial.types)) {
						data["children"] = get(orderByFilial, "types", []).map(
							(type, idx) => {
								return {
									name: type.name,
									count: type.price
								};
							}
						);
					}

					return data;
				}
			);

			return [
				{ name: tr("Итого"), count: get(dashboardDataOrders, "total", []) },
				...data
				//
			];
		} catch (error) {
			return [];
		}
	})();

	return (
		<div>
			<div className="flex items-center !gap-5">
				<DateFilterWrap
					className="mb-20 d-flex"
					initialDefault={"day"}
					withStartHoursAppended={true}
						navigateByDay={true}
				/>

				{isMainOrganization ? (
					<EntityForm.Default>
						{() => {
							return (
								<div>
									<Field
										field={{
											value: activeOrganization
										}}
										handleChange={e => {
											const value = get(e, "value", null);

											dispatch(
												auth.SET_ACTIVE_ORGANIZATION.request({
													activeOrganization: value
												})
											);
										}}
										component={Fields.SelectS1}
										isClearable={true}
										name={"type"}
										placeholder={tr("Выберите")}
										size={"small"}
										optionValue={"value"}
										optionLabel={"label"}
										className="w-[400px]"
										options={organizations.map(organization => {
											return {
												value: organization.id,
												label: organization.name
											};
										})}
									/>
								</div>
							);
						}}
					</EntityForm.Default>
				) : null}
			</div>

			<div className="row pos-relative">
				{isLoading && <Spinner position={"absolute"} />}
				<div className="col-3">
					<div
						onClick={() => setSelectedKey("sales")}
						className={`statistics-card d-panel ${selectedKey === "sales" ? "--active" : ""
							}`}
					>
						<img
							className="statistics-card__icon"
							src={statusUpIcon}
							alt=""
						/>
						<div>
							<div className="statistics-card__label">{tr("Сумма продаж")}</div>
							<div className="statistics-card__value">
								{helpers.convertToReadable(sales)}{" "}
								{defaultCurrency && defaultCurrency.toUpperCase()}
							</div>
						</div>
					</div>

					<div
						onClick={() => setSelectedKey("orders")}
						className={`statistics-card d-panel ${selectedKey === "orders" ? "--active" : ""
							}`}
					>
						<img
							className="statistics-card__icon"
							src={shoppingCartIcon}
							alt=""
						/>
						<div>
							<div className="statistics-card__label">{tr("Заказы")}</div>
							<div className="statistics-card__value">
								{helpers.convertToReadable(orders)}{" "}
								{defaultCurrency && defaultCurrency.toUpperCase()}
							</div>
						</div>
					</div>

					<div
						onClick={() => setSelectedKey("cashboxes")}
						className={`statistics-card d-panel ${selectedKey === "cashboxes" ? "--active" : ""
							}`}
					>
						<img
							className="statistics-card__icon"
							src={emptyWalletIcon}
							alt=""
						/>
						<div>
							<div className="statistics-card__label">{tr("Касса")}</div>
							<div className="statistics-card__value">
								{helpers.convertToReadable(cashboxes)}{" "}
								{defaultCurrency && defaultCurrency.toUpperCase()}
							</div>
						</div>
					</div>

					<div
						onClick={() => setSelectedKey("inputTransactions")}
						className={`statistics-card d-panel ${selectedKey === "inputTransactions" ? "--active" : ""
							}`}
					>
						<img
							className="statistics-card__icon"
							src={moneyReciveIcon}
							alt=""
						/>
						<div>
							<div className="statistics-card__label">
								{tr("Денежный приход")}
							</div>
							<div className="statistics-card__value">
								{helpers.convertToReadable(inputTransactions)}{" "}
								{defaultCurrency && defaultCurrency.toUpperCase()}
							</div>
						</div>
					</div>

					<div
						onClick={() => setSelectedKey("outputTransactions")}
						className={`statistics-card d-panel ${selectedKey === "outputTransactions" ? "--active" : ""
							}`}
					>
						<img
							className="statistics-card__icon"
							src={moneySendIcon}
							alt=""
						/>
						<div>
							<div className="statistics-card__label">
								{tr("Денежный расход")}
							</div>
							<div className="statistics-card__value">
								{helpers.convertToReadable(outputTransactions)}{" "}
								{defaultCurrency && defaultCurrency.toUpperCase()}
							</div>
						</div>
					</div>
					<div className={`statistics-card d-panel`}>
						<img
							className="statistics-card__icon"
							src={moneySendIcon}
							alt=""
							style={{ opacity: 0 }}
						/>
						<div style={{ opacity: 0 }}>
							<div className="statistics-card__label">|</div>
							<div className="statistics-card__value">|</div>
						</div>
					</div>
				</div>

				<div
					className="col-6"
					style={{
						display: "flex",
						flexDirection: "column"
					}}
				>
					<div className="statistics-card d-panel justify-content-between">
						<div className="d-flex align-items-center">
							{sales - outputProducts < 0 ? (
								<img
									className="statistics-card__icon"
									src={dollarCircleRedIcon}
									alt=""
								/>
							) : (
								<img
									className="statistics-card__icon"
									src={dollarCircleIcon}
									alt=""
								/>
							)}
							<div className="">
								<div className="">{tr("Операционная прибыль")}</div>
								<div className="fw-600">
									{helpers.convertToReadable(sales - outputProducts)}{" "}
									{defaultCurrency && defaultCurrencyLabel}
								</div>
							</div>
						</div>
						<div className="d-flex align-items-center">
							{sales - commonTransactions < 0 ? (
								<img
									className="statistics-card__icon"
									src={dollarCircleRedIcon}
									alt=""
								/>
							) : (
								<img
									className="statistics-card__icon"
									src={dollarCircleIcon}
									alt=""
								/>
							)}
							<div className="">
								<div className="">{tr("Общественная прибыль")}</div>
								<div className="fw-600">
									{helpers.convertToReadable(
										sales - commonTransactions - outputProducts
									)}{" "}
									{defaultCurrency && defaultCurrencyLabel}
								</div>
							</div>
						</div>
					</div>

					<div className="d-panel flex-1 mb-10 bg-red-100">
						{selectedKey === "sales" && (
							<>
								<Table
									bordered
									size="middle"
									dataSource={salesByFilialTableData}
									pagination={false}
									rowClassName={rowClassName()}
									columns={[
										{
											title: tr("Филиалы"),
											dataIndex: "name",
											width: 400
										},
										{
											title: tr("Сумма"),
											align: "right",
											render(value, record, idx) {
												const count = helpers.convertToReadable(
													get(record, "count", 0)
												);

												return (
													<>
														{count} {defaultCurrency.toUpperCase()}
													</>
												);
											}
										}
									]}
									rowKey={(row, idx) => get(row, "name", idx)}
								/>
							</>
						)}

						{/* @HERE */}
						{selectedKey === "orders" && (
							<>
								<Table
									bordered
									size="middle"
									dataSource={ordersByFilialTableData}
									pagination={false}
									rowClassName={rowClassName()}
									columns={[
										{
											title: tr("Филиалы"),
											dataIndex: "name",
											width: 450
										},
										{
											title: tr("Сумма"),
											align: "right",
											render(value, record, idx) {
												const count = helpers.convertToReadable(
													get(record, "count", 0)
												);

												return (
													<>
														{count} {defaultCurrency.toUpperCase()}
													</>
												);
											}
										}
									]}
									rowKey={row => row.name}
								/>
							</>
						)}
						{selectedKey === "inputTransactions" && (
							<InputTransactions
								data={get(dashboardData, "inputTransactions", {})}
							/>
						)}
						{selectedKey === "outputTransactions" && (
							<OutputTransactions
								data={get(dashboardData, "outputTransactions", {})}
							/>
						)}
						{selectedKey === "commonTransactions" && (
							<CommonTransactions
								data={get(dashboardData, "commonTransactions", {})}
							/>
						)}
						{selectedKey === "inputProducts" && (
							<>
								<h3 className="font-bold text-2xl my-0">
									{tr("Приход товаров по филиалам")}
								</h3>
								<div className="h-[10px]" />
								<MainOrganizationStorageIncomes isMainPage={true} />
							</>
						)}
						{selectedKey === "outputProducts" && (
							<>
								<h3 className="font-bold text-2xl my-0">
									{tr("Расход товаров по филиалам")}
								</h3>
								<div className="h-[10px]" />
								<MainOrganizationStorageConsumption isMainPage={true} />
							</>
						)}
						{selectedKey === "storageItems" && (
							<MainOrganizationStorageLeftovers isMainPage={true} />
						)}
						{selectedKey === "cashboxes" && (
							<CashRegister data={get(dashboardData, "cashboxes", {})} />
						)}
					</div>
				</div>

				<div className="col-3">
					<div
						onClick={() => setSelectedKey("inputProducts")}
						className={`statistics-card d-panel ${selectedKey === "inputProducts" ? "--active" : ""
							}`}
					>
						<img
							className="statistics-card__icon"
							src={importIcon}
							alt=""
						/>
						<div>
							<div className="statistics-card__label">
								{tr("Приход товаров")}
							</div>
							<div className="statistics-card__value">
								{helpers.convertToReadable(inputProducts)}{" "}
								{defaultCurrency && defaultCurrency.toUpperCase()}
							</div>
						</div>
					</div>

					<div
						onClick={() => setSelectedKey("outputProducts")}
						className={`statistics-card d-panel ${selectedKey === "outputProducts" ? "--active" : ""
							}`}
					>
						<img
							className="statistics-card__icon"
							src={exportIcon}
							alt=""
						/>
						<div>
							<div className="statistics-card__label">
								{tr("Расход товаров")}
							</div>
							<div className="statistics-card__value">
								{helpers.convertToReadable(outputProducts)}{" "}
								{defaultCurrency && defaultCurrency.toUpperCase()}
							</div>
						</div>
					</div>

					<div
						onClick={() => setSelectedKey("storageItems")}
						className={`statistics-card d-panel ${selectedKey === "storageItems" ? "--active" : ""
							}`}
					>
						<img
							className="statistics-card__icon"
							src={boxIcon}
							alt=""
						/>
						<div>
							<div className="statistics-card__label">
								{tr("Остаток склада")}
							</div>
							<div className="statistics-card__value">
								{helpers.convertToReadable(
									get(dashboardData, "storage")
										? Number(dashboardData.storage)
										: 0
								)}{" "}
								{defaultCurrency && defaultCurrency.toUpperCase()}
							</div>
						</div>
					</div>

					<div
						onClick={() => setSelectedKey("commonTransactions")}
						className={`statistics-card d-panel ${selectedKey === "commonTransactions" ? "--active" : ""
							}`}
					>
						<img
							className="statistics-card__icon"
							src={moneySendIcon}
							alt=""
						/>
						<div>
							<div className="statistics-card__label">
								{tr("Общие затраты")}
							</div>
							<div className="statistics-card__value">
								{helpers.convertToReadable(commonTransactions + outputProducts)}{" "}
								{defaultCurrency && defaultCurrency.toUpperCase()}
							</div>
						</div>
					</div>

					<div
						className="statistics-card d-panel"
						onClick={() => navigate("/reports/debt-credit")}
					>
						<img
							className="statistics-card__icon"
							src={convertRedIcon}
							alt=""
						/>
						<div>
							<div className="statistics-card__label">{tr("Кредиторка")}</div>
							<div className="statistics-card__value">
								{helpers.convertToReadable(creditor)}{" "}
								{defaultCurrency && defaultCurrency.toUpperCase()}
							</div>
						</div>
					</div>

					<div
						className="statistics-card d-panel"
						onClick={() => navigate("/reports/debt-credit")}
					>
						<img
							className="statistics-card__icon"
							src={convertIcon}
							alt=""
						/>
						<div>
							<div className="statistics-card__label">{tr("Дебиторка")}</div>
							<div className="statistics-card__value">
								{helpers.convertToReadable(debtor)}{" "}
								{defaultCurrency && defaultCurrency.toUpperCase()}
							</div>
						</div>
					</div>
				</div>
			</div>

			<SalesByDay />

			<div className="row">
				<div className="col-4">
					{categoriesByPrice.length > 0 && (
						<SalesByCategory items={categoriesByPrice} />
					)}
				</div>
				<div className="col-4">
					{topDishes.length > 0 && <TopDishes items={topDishes} />}
				</div>
				<div className="col-4">
					{waiters.length > 0 && (
						<TopWaiters
							items={waiters}
							defaultCurrency={defaultCurrency && defaultCurrency}
						/>
					)}
				</div>
			</div>
		</div>
	);
}

export default MainOrganizationDashboard;
